import React from 'react';
import { aboutData as mockAboutData } from '../data/mock';

const AboutSection = ({ data }) => {
  const aboutData = data || mockAboutData;
  
  return (
    <section
      id="about"
      className="min-h-screen bg-[#5B9BD5] flex items-center justify-center py-20 px-6"
    >
      <div className="max-w-4xl mx-auto">
        <div className="bg-white/10 backdrop-blur-sm border-4 border-white/30 rounded-2xl p-8 md:p-16">
          <div 
            className="inline-block bg-[#F5B041] text-white px-6 py-3 rounded-full mb-8 font-bold text-sm"
            style={{ fontFamily: "'Press Start 2P', monospace" }}
          >
            {aboutData.title}
          </div>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-white text-xl md:text-2xl leading-relaxed mb-6 font-light">
              {aboutData.content.split('\n\n')[0]}
            </p>
            <p className="text-white/90 text-lg md:text-xl leading-relaxed font-light">
              {aboutData.content.split('\n\n')[1]}
            </p>
          </div>

          {/* Decorative elements */}
          <div className="mt-12 flex justify-center space-x-4">
            <div className="w-12 h-12 bg-[#1A532F] rounded-lg transform rotate-45"></div>
            <div className="w-12 h-12 bg-[#F5B041] rounded-full"></div>
            <div className="w-12 h-12 bg-[#E64A2B] rounded-lg"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
